<div class="card-edtech" *ngIf="gallery$ | async as images">
  <div class="card-edtech__background">
    <!-- <img
      class="card-edtech__img1"
      loading="lazy"
      [src]="images[gallery.Smartphone]"
      [alt]="'global.image' | translate"
    /> -->
    <img class="card-edtech__img2" loading="lazy" src="assets/images/phone.png" [alt]="'global.image' | translate" />
    <div class="card-edtech__img3">
      <img loading="lazy" src="assets/images/notebook.png" [alt]="'global.image' | translate" />
    </div>
    <div class="card-edtech__img5">
      <img loading="lazy" src="assets/images/planta2.png" [alt]="'global.image' | translate" />
    </div>
  </div>

  <div class="card-edtech__group">
    <h1 class="card-edtech__title">{{ 'educational-technologies.title' | translate }}</h1>
    <div class="card-edtech__text" [innerHtml]="'educational-technologies.description' | translate"></div>
    <!-- <img class="card-edtech__img4" loading="lazy" [src]="images[gallery.Student2]" [alt]="'global.image' | translate" /> -->
  </div>
</div>
